import React, { Component } from 'react'
import _ from 'lodash'
import { Helmet } from 'react-helmet'
import share from '~/tools/share'
import { trackEvent } from '~/tools/analytics/cleverTap'
import { getVideo, getVideoSignature } from '~/redux/video/helpers'
import StandaloneVideoPlayer01 from '../StandaloneVideoPlayer/StandaloneVideoPlayer01'
import Spinner from '~/components/Spinner'
import connect from "~/tools/connect";
import './styles.css'

class VideoPlayListDetail extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      loading:false,
      selectedVideo:0,
      data:props.data.contentData[0],
      playlistData:props.data.contentData[0].gist,
      videoList:props.data.contentData[0].videoList,
      currentVideo:props.data.contentData[0].videoList[0]
    }
  }

  componentDidMount() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  renderShareContainer = () => {
    return (
      <div className='show__share'>
        <div className='sharing'>
          <i
            className='ion-social-facebook'
            onClick={() => { this.socialShare('Facebook') }}
          />
          <i
            className='ion-social-twitter'
            onClick={() => { this.socialShare('Twitter') }}
          />
          <i
            className='ion-ios-email-outline'
            onClick={() => { this.socialShare('Email') }}
          />
        </div>
      </div>
    )
  }

  socialShare(platform) {
    const { gist = {}, creditBlocks = [], categories = [] } = this.state.data
    categories.push(gist.primaryCategory)
    var videoEventData = {
      contentId: gist.id,
      contentTitle: gist.title,
      contentType: gist.contentType,
      playbackType: 'Streamed'
    }
    creditBlocks.forEach(creditBlock => {
      if (creditBlock.title.trim().toLowerCase() === 'director') {
        videoEventData.directorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
      }
      if (creditBlock.title.trim().toLowerCase() === 'starring') {
        videoEventData.actorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
      }
    })
    videoEventData.contentGenre = categories.map(category => category && category.title).join(',')
    videoEventData.medium = platform
    switch (platform) {
      case 'Facebook':
        share.facebook(window.location.href)
        break;
      case 'Twitter':
        share.twitter(window.location.href, gist.title)
        break;
      case 'Email':
        share.email(window.location.href)
        break;
      default:
        break;
    }
    trackEvent('Shared', videoEventData)
  }

  handleResize = () => {
    let leftSideHeight = document.querySelector(".StandaloneVideoPlayer01").offsetHeight
    document.querySelector(".playlistScroll").style.height = leftSideHeight+'px'
  }
  
  renderDetailsBar = () => {
    return (
      <div className="show__details">
        <div className="show__title__box">
          <span className="title">{this.state.playlistData.title}</span>
        </div>
        <div className="desktop-share">{this.renderShareContainer(this.state.playlistData.title)}</div>
      </div>
    )
  }
  thumbnailImage(item) {
    var w = this.props.maxWidth || 400;
    var gist = item
    var url =
      this.props.thumbnailType === "portrait"
        ? gist.posterImageUrl ||
          _.get(gist.posterImage, "url") ||
          _.get(gist.images, "_3x4Image.secureUrl") ||
          _.get(gist.gist, 'imageGist["_3x4"]') ||
          _.get(window.settings, "images.placeholderPoster")
        : gist.videoImageUrl ||
          _.get(gist.videoImage, "url") ||
          _.get(gist, "landscapeImageUrl") ||
          _.get(gist.images, "_16x9Image.secureUrl") ||
          _.get(gist.gist, 'imageGist["_16x9"]') ||
          _.get(window.settings, "images.placeholderCover");
    if (this.props.thumbnailType === "portrait") {
      return `${url}?impolicy=resize&w=${w}&h=${w * 1.48}`;
    } else {
      return `${url}?impolicy=resize&w=${w}&h=${w * 0.5625}`;
    }
  }
 

  handleClick = (i, id, e) =>  {
    e.preventDefault();
    if (i === this.state.selectedVideo)
      return
    this.setVideo(i, id);
  }

  playNextvideo = () => {
    let nextVideoindex = this.state.selectedVideo + 1
    let nextVideoId = this.state.videoList[nextVideoindex].gist.id
    this.setVideo(nextVideoindex, nextVideoId);
  }

  setVideo = (i, id) => {
    this.setState({loading: true})
    getVideo(id, response => {
      this.setState({currentVideo: response.data.video, selectedVideo:i, loading:false})
    }).catch((error) => {
      this.setState({currentVideo: this.state.videoList[i], selectedVideo:i, loading:false})
    })
  }

  scrollList = () => {
    const elem = document.getElementById('playlistScroll')
    const  scrollDiv = document.querySelector('.playlistScroll');
    const listHeight = document.querySelector(".listWrapper").offsetHeight;
    elem.scrollBy(0, elem.scrollTop+listHeight)
  }

  renderVideoInfo = currentVideoData => {
    return (
      <div className="videoInfo">
        <h3>{currentVideoData.gist.title} {currentVideoData.gist.runtime && <span>{`${Math.round(currentVideoData.gist.runtime / 60)}mins`}</span>}</h3>
        <p>{currentVideoData.gist.description}</p>
      </div>
    )
  }
  renderHelmet = () => {
    const {seo, gist } = this.state.data
    return (
      <Helmet>
        <title>{`${seo.title || gist.title} | ${window.settings.site}`}</title>
        <meta name="description" content={seo.description || gist.description} />
        <meta property="og:type" content="video.tv_show" />
        <meta property="og:title" content={seo.title || gist.title} />
        <meta property="og:description" content={seo.description || gist.description} />
        <meta property="og:image" content={gist.videoImageUrl || gist.imageGist['_16x9']} />
      </Helmet>
    )
  }

  rendervideoPlaylist = () => {
    const items = this.state.videoList
    return(
      <div className={`playlistDetailRight`}>
        { !_.isEmpty(items) && (
          <div id='playlistScroll' className='playlistScroll'>
          { items.map((object, i) => (
            <a href={object.gist.permalink} className={this.state.selectedVideo === i ? "listWrapper active" : "listWrapper"} key={i} onClick={(e) => this.handleClick(i, object.gist.id, e)}>
              <div className="thumbnail">
                <img src={this.thumbnailImage(object)} />
                <div className="play-button site-color"><i className="ion-ios-play"></i></div>
              </div>
              <div className="itemInfo">
                <h4>{object.gist.title}</h4>
                <p>{object.gist.runtime && <span>{`${Math.round(object.gist.runtime / 60)}mins`}</span>}</p>
              </div>
            </a>
            )) 
          }
          </div>
        )}
      </div>
    )   
  }

  render() {
    let currentVideoData = this.state.currentVideo
    let nextVideoData = this.state.videoList[this.state.selectedVideo+1]
    let videoPlayerData = {
      contentData : [{
        ...currentVideoData
      }]
    }
    return (
      <div className="show">
        { this.renderHelmet() }
        { this.renderDetailsBar() }
        <div className="playerListWrapper">
          <div className="playerWrapper">
            { this.state.loading ? <div className='loadingWrapper site-color'><Spinner /></div> :
            <div>
              <StandaloneVideoPlayer01 data={videoPlayerData} nextVideoDataAction={{playNextAction:this.playNextvideo, nextVideoData: {...nextVideoData}}} isPlaylistItem={true} />
              {this.renderVideoInfo(currentVideoData)} 
            </div>
            }
          </div>
          { this.rendervideoPlaylist() }
        </div>
      </div>
    )
  }
}

var userStore = require('~/redux/user/store')
connect(VideoPlayListDetail, state => ({ user: state.user }), userStore)

export default VideoPlayListDetail;